import { useContext } from "react";
import { useSelector } from "react-redux";

import { useExperiment } from "../../hooks/useExperiment";
import { sortedCompaniesSelector } from "../../selectors/companies";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const useFoldPlacementCompanies = ({ experimentKey, placements }) => {
	const companies = useSelector(sortedCompaniesSelector);
	const isExperimentOn = useExperiment(experimentKey);

	return isExperimentOn ? companies.slice(0, placements.length) : [];
};

export const useFoldPlacement = (placements) => {
	const { companyIndex } = useContext(CompanyContext);
	const placement = placements[companyIndex];
	const highlightSetting = useSelector(
		(state) => state.verticalSettings?.[placement.settingsKey],
	);

	return {
		...placement,
		highlightText: highlightSetting ?? placement.highlightDefault,
	};
};
